import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-1403">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1404">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-1405">
          <SectionHeading title="Cine sunt eu și de ce am creat cursul Abundența Iubirii" centered={true} data-id="element-1406" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-1407">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-1408">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-1409" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-1410" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-1411" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-1412">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1413" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-1414">
            <div className="hidden lg:block" data-id="element-1415">
              <SectionHeading title="Cine sunt eu și de ce am creat cursul Abundența Iubirii" centered={false} data-id="element-1416" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-1417">
              <p data-id="element-1418">
                Sunt <strong data-id="element-1419">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-1420">
                Am creat cursul Abundența Iubirii pentru că am înțeles un lucru
                simplu dar profund: totul începe cu iubirea de sine. Oamenii
                care vin la mine cu blocaje financiare, cu stres, cu relații
                tensionate, toți au un lucru în comun: nu se iubesc suficient.
                Nu se simt demni de iubire, de abundență, de o viață bună.
              </p>
              <p data-id="element-1421">
                Acest curs aduce laolaltă exerciții practice din metoda Louise
                Hay, tehnici de eliberare emoțională din Theta Healing® și
                meditații ghidate care te conectează cu iubirea la cel mai
                profund nivel. Nu e teorie despre iubire. E un spațiu în care
                simți iubirea, o practici și o integrezi în viața ta de zi cu
                zi.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-1422">
                Ceea ce îmi spun cursanții cel mai des este că simt iubirea din
                primul moment și că intră într-o stare pe care nu o întâlnesc în
                altă parte.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-1423">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-1424">
                  "Asta aduc în fiecare curs: un spațiu sigur, cald și plin de
                  iubire în care transformarea vine natural."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-1425" />
          </motion.div>
        </div>
      </div>
    </section>;
}